import React from 'react';

import {
    informationPill,
    informationPillLabel,
} from './information-pill.module.styl';

type Props = {
    label: React.ReactNode,
    value?: React.ReactNode,
};

export const InformationPill: React.FC<Props> = ({label, value}) => (
    <div className={informationPill}>
        <strong className={informationPillLabel}>
            {label}
        </strong>
        {value}
    </div>
);
